var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "font-normal text-lg rounded p-4 w-full mb-4",
      class: _vm.getBorder,
    },
    [
      _c(
        "p",
        {
          staticClass:
            "font-400 labelWidth leading-6 mb-0.5 text-primary-black text-lg",
        },
        [_vm._v(" " + _vm._s(_vm.jobTitle) + " ")]
      ),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "flex flex-row" },
            [
              _c(
                "CardBodyItem",
                { staticClass: "mb-0.5", attrs: { content: _vm.companyName } },
                [
                  _c("p", { staticClass: "text-storm-gray font-400 text-lg" }, [
                    _vm._v(" " + _vm._s(_vm.companyName) + " "),
                  ]),
                ]
              ),
              _vm.employmentType
                ? _c(
                    "span",
                    { staticClass: "p-2 flex items-center" },
                    [_c("DotIcon")],
                    1
                  )
                : _vm._e(),
              _c("CardBodyItem", { staticClass: "mb-0.5" }, [
                _c("p", { staticClass: "text-storm-gray font-400 text-lg" }, [
                  _vm._v(_vm._s(_vm.employmentType)),
                ]),
              ]),
            ],
            1
          ),
          _c("CardBodyItem", {
            staticClass: "mb-0.5",
            attrs: { content: _vm.industryName },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex flex-row" },
        [
          _vm.formattedStartDate
            ? _c("CardBodyItem", {
                staticClass: "mb-0.5",
                attrs: { content: _vm.formattedStartDate, label: "" },
              })
            : _vm._e(),
          _vm.formattedEndDate
            ? _c("span", { staticClass: "px-1 -mt-0.5 text-gray-new" }, [
                _vm._v("-"),
              ])
            : _vm._e(),
          _vm.formattedEndDate
            ? _c("CardBodyItem", {
                staticClass: "mb-0.5",
                attrs: { content: _vm.formattedEndDate, label: "" },
              })
            : _vm._e(),
          _c(
            "span",
            { staticClass: "p-2 flex items-center" },
            [_vm.location ? _c("DotIcon") : _vm._e()],
            1
          ),
          _vm.location
            ? _c("CardBodyItem", {
                staticClass: "mb-0.5",
                attrs: { content: _vm.location },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.summary
        ? _c(
            "CardBodyItem",
            { staticClass: "xxlLabelContainer mb-0.5" },
            [
              _c("CollapsibleDescription", {
                attrs: { description: _vm.summary },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }